import React from "react";
import { BookOpen, Copy } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Documentation() {
  const { user } = useAuth();
  const webhookUrl = `${window.location.origin}/webhook`;
  const primaryLicense = user?.license_ids?.[0] || "YOUR_LICENSE_ID";
  const payload = `{
  "license_id": "${primaryLicense}",
  "symbol": "{{ticker}}",
  "action": "BUY",
  "price": {{close}},
  "sl": 0,
  "tp": 0,
  "lot": 0.01,
  "comment": "TradingView signal",
  "magic": 123456
}`;

  const copy = (text) => navigator.clipboard.writeText(text);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Setup Documentation</div>
          <div className="page-sub">Connect TradingView Pine Script alerts with your MT5 EA</div>
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <a 
            href="https://www.tradingview.com/pine-script-docs/en/v5/Introduction.html" 
            target="_blank" 
            rel="noreferrer" 
            className="btn btn-primary"
            style={{ fontSize: "12.5px", padding: "8px 16px", minHeight: "auto", display: "inline-flex", alignItems: "center", gap: "6px" }}
          >
            <BookOpen size={14} />
            Official Pine Script v5 Manual
          </a>
        </div>
      </div>

      <div className="docs-layout">
        <section className="card docs-card">
          <div className="card-header">1. Add Pine Script</div>
          <div className="docs-body">
            <p>TradingView chart open karein, Pine Editor mein sample Pine Script paste karein, phir Add to chart par click karein.</p>
            <p>Sample script Downloads page se mil jayega. Aap apni existing Pine Script mein bhi alert message JSON format add kar sakte hain.</p>
          </div>
        </section>

        <section className="card docs-card">
          <div className="card-header">2. Create TradingView Alert</div>
          <div className="docs-body">
            <p>Alert create karte waqt Webhook URL enable karein aur niche wala URL paste karein.</p>
            <div className="code-row">
              <code>{webhookUrl}</code>
              <button className="icon-btn" onClick={() => copy(webhookUrl)} title="Copy URL"><Copy size={15} /></button>
            </div>
          </div>
        </section>

        <section className="card docs-card">
          <div className="card-header">3. Alert Message JSON</div>
          <div className="docs-body">
            <p>TradingView alert message box mein JSON payload paste karein. BUY, SELL, CLOSE_BUY, CLOSE_SELL, CLOSE_ALL actions supported hain.</p>
            <pre className="code-block">{payload}</pre>
            <button className="btn btn-ghost" onClick={() => copy(payload)}>
              <Copy size={15} />
              Copy Payload
            </button>
          </div>
        </section>

        <section className="card docs-card">
          <div className="card-header">4. MT5 EA Setup</div>
          <div className="docs-body">
            <p>Downloads page se EA file download karein, MT5 Experts folder mein place karein, AutoTrading enable karein, aur EA inputs mein LicenseID set karein.</p>
            <p>Har user ko 3 unique license IDs milti hain. Aap apne end clients ko unmein se license ID provide kar sakte hain.</p>
          </div>
        </section>
      </div>
    </div>
  );
}
